var map = {
  "./desktop/index.js": [
    "77661",
    "3199",
    "76390",
    "98085",
    "64740"
  ],
  "./desktop/index": [
    "77661",
    "3199",
    "76390",
    "98085",
    "64740"
  ],
  "./mobile": [
    "40969",
    "3199",
    "76390",
    "98085",
    "80736"
  ],
  "./desktop": [
    "77661",
    "3199",
    "76390",
    "98085",
    "64740"
  ],
  "./desktop/": [
    "77661",
    "3199",
    "76390",
    "98085",
    "64740"
  ],
  "./mobile/": [
    "40969",
    "3199",
    "76390",
    "98085",
    "80736"
  ],
  "./mobile/index": [
    "40969",
    "3199",
    "76390",
    "98085",
    "80736"
  ],
  "./mobile/index.js": [
    "40969",
    "3199",
    "76390",
    "98085",
    "80736"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 18393;
module.exports = __rspack_async_context;
